import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { LineandSectionPropertiesList } from './lineandSectionPropertiesDetails.types';

export const lineandSectionPropertiesListPullQueryBuilder = (
  document: LineandSectionPropertiesList,
) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mobileAssetSectionPropertiesListFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime
    ) {
      mobileAssetSectionPropertiesListFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        assetId
        dateCreated
        dateModified
        siteId
        disciplineId
        assetSection {
          fromMajorAsset
          toMajorAsset
          temperature
          ksi
          name
          description
          fkSectionDefinition
          assetSectionArea {
            fkArea
            fkAssetSection
            pkAssetSectionArea
          }
          assetSectionMetalicPropertyValue {
            dOd
            sAllowableUnitStress
            pkAssetSectionMetalicPropertyValue
            designCorrosionAllowance
            eLongitudeQualityFactor
            pInternalDesignGause
          }
          assetSectionPropertyValue {
            pkAssetSectionPropertyValue
            value
            fkAssetSection
            fkSectionPropertyDefinition
          }
          sectionCmlattribute {
            cmlcode
            surface
            access
            active
            alarm
            fitting
            id
            readingUser
            refMeasurment
            cubeId
            dateReading
            sectionCmlattributeValue {
              at3
              at6
              at9
              at12
              fkSectionCmlattribute
              utMeasurement
              id
            }
          }
        }
        assetArea {
          assetId
          areaId
          pcsId
          assetName
          assetCategory
          site
          discipline
          layer
          parentAreaId
          parentAreaPcsId
          pkAssetArea
          areaName
          namePcsid
          fkAreaType
        }
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc?.siteId,
        doc?.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};
